import { FC } from "react";
import logoIMCImage from "../../../assets/imc_logo.png";
import logoFotovoltaicoSempliceImage from "../../../assets/fotovoltaticoSemplice_logo.png";
import {
  StyledMedia,
  StyledMediaBody,
  StyledImage,
  StyledSignin,
} from "./style";
import SigninForm from "../SigninForm";
import { AlertMessage } from "../../../types";

type Props = {
  isSubmitting: boolean;
  message?: AlertMessage;
  onSubmit: (username: string, password: string) => void;
};

const AuthContainer: FC<Props> = ({ message, isSubmitting, onSubmit }) => {
  return (
    <StyledMedia>
      <StyledMediaBody
        style={{
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <StyledImage>
          <img src={logoIMCImage} alt="IMCHolding" />
        </StyledImage>
        <StyledImage>
          <img
            src={logoFotovoltaicoSempliceImage}
            alt="Fotovoltaico Semplice"
          />
        </StyledImage>
      </StyledMediaBody>
      <StyledSignin>
        <SigninForm
          onSubmit={onSubmit}
          isSubmitting={isSubmitting}
          message={message}
        />
      </StyledSignin>
    </StyledMedia>
  );
};

export default AuthContainer;
